import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { getConsolidatedForecastingUrl, PREDICT_PRODUCT_SLUG, ROUTES } from '@futrli/shared-services';
import { LoadingWizardScreen } from '@futrli/ui-components/components/sidebar/wizard/screens/loading-wizard-screen/loading-wizard-screen';

import { BudgetCreatedWizardScreen } from '../create-budget-wizard-container/screens/budget-created-wizard-screen';
import { BudgetCreatingWizardScreen } from '../create-budget-wizard-container/screens/budget-creating-wizard-screen';
import { ConsolidatedBudgetFormWizardScreen } from './screens/consolidated-budget-form-wizard-screen';
import { ForecastType as ForecastTypeType } from '../../../dashboard/types';
import { trackCreateForecastEvent } from '../../../dashboard/utils';
import { useCreateConsolidatedForecastWizardContext } from '../../contexts/create-consolidated-forecast-wizard-context';

export interface CreateConsolidatedBudgetWizardContainerProps {
  onClose: () => void;
}

export const CreateConsolidatedBudgetWizardContainer = ({ onClose }: CreateConsolidatedBudgetWizardContainerProps) => {
  const navigate = useNavigate();

  const { consolidationId, workspaceId, form, view } = useCreateConsolidatedForecastWizardContext();
  const { errorCreating, isCreating, isLoading, newConsolidatedForecastId } = view.state;

  const { getRequestData, validate } = form;

  const error = errorCreating ? true : '';

  const screen = (() => {
    if (isLoading) {
      return 'loading';
    }
    if (isCreating) {
      return 'creating';
    }
    if (newConsolidatedForecastId) {
      return 'created';
    }
    return 'form';
  })();

  const handleCreate = () => {
    if (validate()) {
      view.createConsolidatedForecast(getRequestData());
    }
  };

  const handleView = () => {
    if (newConsolidatedForecastId) {
      trackCreateForecastEvent(ForecastTypeType.BUDGET);
      const basePath = getConsolidatedForecastingUrl(workspaceId, consolidationId, PREDICT_PRODUCT_SLUG);
      onClose();
      navigate(`${basePath}/${newConsolidatedForecastId}${ROUTES.PREDICTIONS}${ROUTES.SALES}`);
    }
  };

  useEffect(() => {
    if (newConsolidatedForecastId) {
      // Refresh consolidated forecasts cache?
    }
  }, [newConsolidatedForecastId, onClose]);

  return (
    <>
      {screen === 'loading' && <LoadingWizardScreen />}
      {screen === 'form' && (
        <ConsolidatedBudgetFormWizardScreen error={error} onClose={onClose} onCreate={handleCreate} />
      )}
      {screen === 'creating' && <BudgetCreatingWizardScreen />}
      {screen === 'created' && <BudgetCreatedWizardScreen onClose={onClose} onView={handleView} />}
    </>
  );
};
